<template>
  <div class="container">
    <h1 class="title is-2">Services</h1>

    <div class="columns is-vcentered">
      <div class="column">
        <figure class="image">
          <img src="../assets/Phil2.jpg" alt="Chess clubs in schools" />
        </figure>
      </div>

      <div class="column">
        <h3 class="subtitle is-3 service-title">Chess clubs in schools</h3>

        <div class="service-description">
          <p>I have taught in over 20 schools across London since 2013, offering children of all ages the chance to learn chess in a supportive, professional and - most importantly - fun setting. I see extra-curricular clubs as a place to develop skills that are necessary beyond the classroom. Chess offers a platform to learn about planning, problem solving, teamwork and sportsmanship.</p>

          <p>Each term I run internal club tournaments, awarding prizes including trophies for the top finishers and the most improved players. In the spring term I enter schools into the qualification rounds of the <a href="https://www.delanceyukschoolschesschallenge.com/" target="_blank">Delancey UK Schools’ Chess Challenge</a>. In addition there are opportunities to compete in team events such as She Plays To Win, online interschool battles, and the <a href="https://www.epsca.org.uk/npscc.html" target="_blank">National Primary School Championships</a>.</p>
        </div>
      </div>
    </div>
    
    <div class="columns is-vcentered reverse-row-order">

      <div class="column">
        <figure class="image">
          <img src="../assets/Phil7.png" alt="One-to-one coaching" />
        </figure>
      </div>

      <div class="column">
        <h3 class="subtitle is-3 service-title">One-to-one coaching</h3>
          <div class="service-description">
            <p>I offer private lessons within London, or online worldwide! I will provide you with an individually tailored coaching programme of fun and engaging lessons. Check out some <router-link to="/">student testimonials</router-link> to see what you are missing.</p>

            <pI help students of all ages to develop their fundamentals and bring these improved skills to competitive tournament play should you wish. Since founding Makepeace With Chess, it has been a pleasure to teach a range of beginners, intermediate and advanced players. I guarantee to provide all students with new challenges to overcome.</p>

            <p>If you have the time and willingness to improve your game, one-to-one coaching is the way forward. Please get in touch to find out about my competitive rates and what's included.</p>

          </div>
      </div>
    </div>

    <div class="columns is-vcentered">
      <div class="column">
        <figure class="image" >
          <img src="../assets/janflyer.jpg" alt="Online courses" />
        </figure>
      </div>

      <div class="column">
        <h3 class="subtitle is-3 service-title">Online courses</h3>

          <div class="service-description">
            <p>I also offer intensive group courses for adult beginners and improvers. I initially introduced them to offer parents a chance to learn alongside their children whom I already teach, but the pandemic and the release of The Queen's Gambit broadened their appeal. The next course is in early 2023. Opposite is the flyer for it. Places are limited so don't delay!</p>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      // data model
    }
  },
  head: {
    title: function () {
      return {
        inner: 'Services',
        separator: '-'
      }
    },
    meta: [
      { name: 'description', content: 'Details of the services offered by Makepeace With Chess, including chess classes in schools and one-to-one coaching.' }
    ]
  }
}
</script>

<style lang="sass">

.service-description
  margin-bottom: 20px

  p
    margin-bottom: 16px

.photo-credit
  font-size: 0.75em
  font-style: italics

@media only screen and (min-width: 769px)
  .reverse-row-order
    display: flex
    flex-direction: row-reverse

</style>



// WEBPACK FOOTER //
// Services.vue?4b70ede9